import { FlagKeys } from 'containers/flags'
import { OperationsSortCriteria } from '../tab-panels/UsageMetrics/types'

export interface DisplayOperationCosts {
  requestsCount: boolean
  maxRequestDuration: boolean
  totalRequestsDuration: boolean
  lastRequestDuration: boolean
  dbQueryCount: boolean
  dbQueryTotalDecodeTime: boolean
  dbQueryTotalQueryTime: boolean
  dbQueryTotalQueueTime: boolean
  dbQueryTotalTime: boolean
}

export interface DevToolsSettingsState {
  general: {
    isTurnedOn: boolean
  }
  ui: {
    isVisible: boolean
    isPinned: boolean
    pinnedTo: 'left' | 'right'
    width: number
    selectedTab: number
  }
  featureFlags: { overrides: { [flag in FlagKeys]?: boolean } }
  usageMetrics: {
    isTurnedOn: boolean
    selectedTab: number
    sortFieldPathsBy: 'costs' | 'none'
    filter: string
    sortBy: OperationsSortCriteria
    displayOperationCosts: DisplayOperationCosts
  }
  webRenderer: {
    mode: 'release' | 'debug'
    showTilesBorders: boolean
    showPageOrigin: boolean
  }
  dummyData: {
    isTurnedOn: boolean
    logRequests: boolean
    delaySeconds: number
  }
}

export const defaultValues: DevToolsSettingsState = {
  general: { isTurnedOn: false },
  featureFlags: { overrides: {} },
  ui: {
    isPinned: false,
    pinnedTo: 'left',
    width: 800,
    selectedTab: 0,
    isVisible: false,
  },
  usageMetrics: {
    isTurnedOn: false,
    selectedTab: 0,
    sortFieldPathsBy: 'costs',
    filter: '',
    sortBy: OperationsSortCriteria.DEFAULT,
    displayOperationCosts: {
      requestsCount: true,
      maxRequestDuration: true,
      totalRequestsDuration: true,
      lastRequestDuration: false,
      dbQueryCount: true,
      dbQueryTotalDecodeTime: false,
      dbQueryTotalQueryTime: false,
      dbQueryTotalQueueTime: false,
      dbQueryTotalTime: false,
    },
  },
  webRenderer: {
    mode: 'release',
    showTilesBorders: false,
    showPageOrigin: false,
  },
  dummyData: {
    isTurnedOn: false,
    logRequests: false,
    delaySeconds: 1,
  },
}

export type PartialDevToolsSettings = DeepPartial<DevToolsSettingsState>
